export const lensAddresses = {
  accountLens: "0x0A832AA05137A28f020987baF743892AEc747912",
  eulerEarnVaultLens: "0x0000000000000000000000000000000000000000",
  irmLens: "0x0000000000000000000000000000000000000000",
  oracleLens: "0xFCA15e8b1893F41077358476b2E22ab0BeEB324f",
  utilsLens: "0xf8d25D4d0A2c286F60361C22CC3C12317d4246FA",
  vaultLens: "0x0000000000000000000000000000000000000000",
} as const
